module.exports = "https://static.wagwalking.com/_next/static/images/background-desktop-ac6d6e5f050268783773d892d736d189.png";